import { Clerk } from '@clerk/clerk-js';

export let clerkInstance = new Clerk(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);

export const getAuthSession = async () => {
	await clerkInstance.load?.();

	const email = clerkInstance.user?.primaryEmailAddress?.emailAddress;
	const token = await clerkInstance.session?.getToken();

	return { email, token, userId: clerkInstance.user?.id };
};

export const setClerkInstance = async (clerk) => {
	clerkInstance = clerk;
};

export const switchToOrganization = async (organizationId) => {
	await clerkInstance.load?.();
	await clerkInstance.user.reload();

	await clerkInstance.setActive({
		organization: organizationId
	});

	// Force Clerk instance to reload from servers
	await clerkInstance.load?.();
	await clerkInstance.user.reload();
};

export const getOrganizationMemberships = async (organizationId) => {
	const organization = await clerkInstance.getOrganization(organizationId);
	const response = await organization.getMemberships();
	return response.data || response;
};
